module.exports = __webpack_public_path__ + "img/Event_Icon_Merch_Blue.1889e4b9.png";